
import { useContext } from 'react';
import SettingContext from '../../services/context/setting-contentxt/setting-context'
import { SimpleCheckbox } from '../FormElements/FormElements';
import { CellContainer } from './cell_container';

interface iProps {columns:any[],
    onSelect:Function,item_id:string ,tr_index:number,state_length:number ,cols_max_width?:string[]}
    
export function RowContainer (props:iProps) {
  const {isPc, isMobile} =useContext(SettingContext)
    const selectRow = (
        e: React.MouseEvent<HTMLTableRowElement>,
        id?: string,
      ) => {
        // Toggle active class
        e.currentTarget.classList.toggle('active');
  
        // Toggle checkbox
        let checkbox: HTMLInputElement | null = e.currentTarget.querySelector(
          "input[type='checkbox']",
        );
        checkbox?.click();
  
        // Fire select function
        if (props.onSelect && id) props.onSelect(id);
      };
    
    return (
        <tr

        key={props.item_id +`${props.tr_index}`}
        style={{ zIndex: props.state_length - props.tr_index 
          }}
        onClick={(e: React.MouseEvent<HTMLTableRowElement>) => {
          if (props.onSelect) {
            selectRow(e, props.item_id);
          }
        }}>
        {props.onSelect && (
          <td width="50" >
            <SimpleCheckbox
              className="select-row"
              onClick={(
                e: React.MouseEvent<HTMLTableDataCellElement>,
              ) => e.stopPropagation()}
            />
          </td>)}
          {
            
            props.columns.map((ele,i)=> {
              return ( <CellContainer 
                content={ele} key={i +`${props.tr_index}`+props.item_id}
                isPc={isPc} isMobile = {isMobile}
                />)
                   
               
            })
            
          }
          </tr>
    )
}